import { getBlogs } from './Blogs'
import { getCategories } from './Categories'

export { getBlogs, getCategories }
